var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',[(_vm.ready)?_c('router-view'):_vm._e(),(_vm.ready)?_c('p-toast'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }